import { Text } from 'foundations-components/components/Text';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import BestValueBadge from '../../../components/common/badges/BestValueBadge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardLayoutGrid = styled.div.withConfig({
  displayName: "CardLayout__CardLayoutGrid",
  componentId: "b5ykia-0"
})(({
  theme
}) => {
  return {
    display: 'grid',
    gridTemplateAreas: `
      'header header content'
      'price price content'
      'cta cta content'
    `,
    columnGap: theme.space['0'],
    [trellisBreakpoint.tablet]: {
      gridTemplateAreas: `
        'header header header'
        'content content content'
        '. price .'
        'cta cta cta'
      `,
      gap: theme.space['400'],
      justifyContent: 'center'
    }
  };
});
const CardLayout = ({
  title,
  description = null,
  content = null,
  priceComponent = null,
  ctasComponent = null
}) => {
  return /*#__PURE__*/_jsx(CardWrapper, {
    children: /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsxs(CardLayoutGrid, {
        children: [/*#__PURE__*/_jsx(TFlex, {
          position: "absolute",
          insetBlockStart: "300",
          insetInlineEnd: "300",
          zIndex: 1,
          display: "inline-block",
          inlineSize: "fit-content",
          children: /*#__PURE__*/_jsx(BestValueBadge, {})
        }), /*#__PURE__*/_jsx(PPUIGridItem, {
          gridArea: "header",
          children: /*#__PURE__*/_jsxs(TFlex, {
            zIndex: 2,
            display: "block",
            position: "relative",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h3",
              typography: "body-500",
              marginBlockEnd: "200",
              children: title
            }), /*#__PURE__*/_jsx(Text, {
              as: "p",
              children: description
            })]
          })
        }), /*#__PURE__*/_jsx(PPUIGridItem, {
          gridArea: "price",
          children: priceComponent
        }), /*#__PURE__*/_jsx(PPUIGridItem, {
          gridArea: "cta",
          children: ctasComponent
        }), /*#__PURE__*/_jsx(PPUIGridItem, {
          gridArea: "content",
          children: content
        })]
      })
    })
  });
};
export default CardLayout;